<template>
  <main class="main mobile_device_info" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="content_1">
        <div class="device_img">
          <img :src="selectColorImage" alt="" />
        </div>
        <div class="device_name_color">
          <div class="d_name">
            {{ mobileDeviceInfo.modelName }}
          </div>
          <div class="d_date">{{ mobileDeviceInfo.releaseDate }} 출시</div>
          <div class="d_color_name">- {{ selectColorName }}</div>
          <div class="d_color_pic">
            <ul>
              <li v-for="(item, index) in mobileDeviceInfo.colors" :key="index">
                <div
                  class="color_list"
                  :class="{ on: selectColorIndex == index }"
                  @click="setDeviceColor(index)"
                >
                  <div
                    class="color_sel"
                    :style="`background-color:#${item.colorCode}`"
                  ></div>
                  <div class="color_check">
                    <img
                      :src="
                        require(`@/assets/front/images/mobile/ic_color_check.svg`)
                      "
                      alt=""
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_2">
        <div class="con_spec">
          <div class="device_spec_1">
            <div
              class="device_spec"
              v-for="(items, index1) in deviceSpec1"
              :key="index1"
            >
              <div
                class="spec_list"
                v-for="(item, index2) in items"
                :key="index2"
              >
                <div class="spec_img">
                  <img
                    :src="require(`@/assets/front/images/mobile/${item.img}`)"
                    alt=""
                  />
                </div>
                <div class="spec_title">{{ item.name }}</div>
                <div v-if="index1 == 0 && index2 == 0" class="spec_txt">
                  {{ mobileDeviceInfo.os }}
                </div>
                <div v-else-if="index1 == 0 && index2 == 1" class="spec_txt">
                  {{ mobileDeviceInfo.ram }}
                </div>
                <div v-else-if="index1 == 0 && index2 == 2" class="spec_txt">
                  {{ mobileDeviceInfo.battery }}
                </div>
                <div v-else-if="index1 == 1 && index2 == 0" class="spec_txt">
                  {{ mobileDeviceInfo.size }}
                </div>
                <div v-else-if="index1 == 1 && index2 == 1" class="spec_txt">
                  {{ mobileDeviceInfo.memoryEmb }}
                </div>
                <div v-else-if="index1 == 1 && index2 == 2" class="spec_txt">
                  {{ mobileDeviceInfo.memoryExt }}
                </div>
                <div v-else-if="index1 == 2 && index2 == 0" class="spec_txt">
                  {{ mobileDeviceInfo.display }}
                </div>
                <div v-else-if="index1 == 2 && index2 == 1" class="spec_txt">
                  {{ mobileDeviceInfo.cpu }}
                </div>
                <div v-else-if="index1 == 2 && index2 == 2" class="spec_txt">
                  {{ mobileDeviceInfo.camera }}
                </div>
              </div>
            </div>
          </div>
          <div class="device_spec_2">
            <div
              class="device_spec"
              v-for="(item, index) in deviceSpec2"
              :key="index"
            >
              <div class="device_txt_1">{{ item.title }}</div>
              <div
                v-if="index == 0"
                class="device_txt_2"
                v-html="
                  $options.filters.nl2br(
                    decodeBase64(mobileDeviceInfo.specialExplain),
                  )
                "
              ></div>
              <div
                v-else-if="index == 1"
                class="device_txt_2"
                v-html="
                  $options.filters.nl2br(
                    decodeBase64(mobileDeviceInfo.designExplain),
                  )
                "
              ></div>
              <div
                v-else-if="index == 2"
                class="device_txt_2"
                v-html="
                  $options.filters.nl2br(
                    decodeBase64(mobileDeviceInfo.cameraExplain),
                  )
                "
              ></div>
              <div
                v-else-if="index == 3"
                class="device_txt_2"
                v-html="
                  $options.filters.nl2br(
                    decodeBase64(mobileDeviceInfo.componentExplain),
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button class="btn bo" @click="goDetailView()">
            상세 보기
          </button>
          <button class="btn" @click="enterChatRoom()">
            <i class="i_nav_chat_white"></i>
            상담하기
          </button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: 'mobile_device_info',
  components: {},
  data() {
    return {
      isCompleted: false,
      deviceId: 0,
      id: 0,
      selectColorIndex: 0,
      selectColorCode: '',
      selectColorName: '',
      selectColorImage: '',
      mobileDeviceInfo: {},
      deviceSpec2: [
        {
          title: 'Special',
        },
        {
          title: 'Design',
        },
        {
          title: 'Camera',
        },
        {
          title: '구성품',
        },
      ],
      deviceSpec1: [
        [
          {
            img: 'ic_option_01.svg',
            name: 'OS',
          },
          {
            img: 'ic_option_02.svg',
            name: 'RAM',
          },
          {
            img: 'ic_option_03.svg',
            name: '배터리',
          },
        ],
        [
          {
            img: 'ic_option_04.svg',
            name: '화면크기',
          },
          {
            img: 'ic_option_05.svg',
            name: '내장메모리',
          },
          {
            img: 'ic_option_06.svg',
            name: '외장메모리',
          },
        ],
        [
          {
            img: 'ic_option_07.svg',
            name: '디스플레이',
          },
          {
            img: 'ic_option_08.svg',
            name: 'CPU',
          },
          {
            img: 'ic_option_09.svg',
            name: '카메라',
          },
        ],
      ],
    };
  },
  async created() {
    if (!this.$route.query.deviceId || !this.$route.query.id) {
      this.$router.go(-1);
    }

    this.deviceId = this.$route.query.deviceId;
    this.id = this.$route.query.id;

    await this.getDeviceInfo();
    await this.setDeviceColor(0);
    this.isCompleted = true;
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async mounted() {},
  computed: {},
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_DEVICE_DETAIL,
      mobileTypes.MOBILE_DEAL_CHAT,
    ]),
    toCurrency(val) {
      return util.toCurrency(val);
    },
    decodeBase64(val) {
      return util.decodeBase64(val);
    },
    async getDeviceInfo() {
      let params = {
        id: this.deviceId,
      };
      let mobileDeviceDetail = await this[
        mobileTypes.SELECT_MOBILE_DEVICE_DETAIL
      ](params);

      console.log('mobileDeviceDetail');

      console.log(mobileDeviceDetail);

      this.mobileDeviceInfo = mobileDeviceDetail.content;
    },
    goDetailView() {
      this.$router.push({
        name: 'Mobile.DealDetail',
        query: {
          id: this.id,
          dl: this.$route.query.dl,
        },
      });
    },
    async enterChatRoom() {
      // this[userTypes.FETCH_ME]()
      //   .then(res => {
      //     console.log('successsuccesssuccesssuccesssuccess');
      //     console.log(res);
      //     const params = {
      //       id: this.id,
      //     };

      //     this[mobileTypes.MOBILE_DEAL_CHAT](params)
      //       .then(res => {
      //         console.log('resresresresresresres');
      //         console.log(res);

      //         this.$router.push({
      //           name: 'chat.room',
      //           params: {
      //             uuid: res,
      //           },
      //         });
      //       })
      //       .catch(e => {
      //         console.log('error');
      //       });
      //   })
      //   .catch(e => {
      //     console.log('errorerrorerrorerrorerrorerrorerror');
      //   });

      // 로그인 체크
      const isAuth = await util.isAuth();
      if (isAuth) {
        console.log('successsuccesssuccesssuccess');
        const params = {
          id: this.id,
        };

        this[mobileTypes.MOBILE_DEAL_CHAT](params)
          .then(res => {
            console.log('resresresresresresres');
            console.log(res);

            this.$router.push({
              name: 'chat.room',
              params: {
                uuid: res,
              },
            });
          })
          .catch(e => {
            console.log('error');
          });
      } else {
        console.log('비로그인');

        this.$router.push({
          name: 'Auth.Login',
          query: {
            dl_id: this.$route.query.dl + '_' + this.id,
          },
        });
      }
    },
    setDeviceColor(index) {
      this.selectColorIndex = index;
      this.selectColorCode = this.mobileDeviceInfo.colors[index].colorCode;
      this.selectColorName = this.mobileDeviceInfo.colors[index].colorName;
      this.selectColorImage = this.mobileDeviceInfo.colors[index].colorImage;
    },
  },
};
</script>
